import axios from 'axios'
import {notify} from '@kyvg/vue3-notification';

const ENDPOINT = '/v1/tickets'

export default {

    namespaced: true,

    state: () => ({
        tickets: [],
        ticket: {},
        users: [],
        loading: false,
        formLoading: false,
    }),

    mutations: {
        SET_TICKETS(state, payload) {
            state.tickets = payload
        },

        SET_USERS(state, payload) {
            state.users = payload
        },

        SET_TICKET(state, payload) {
            state.ticket = payload
        },

        SET_LOADING(state, payload) {
            state.loading = payload
        },

        SET_FORMLOADING(state, payload) {
            state.formLoading = payload
        },
    },

    getters: {
        prepareOptionsUsers(state) {
            return state.users.map((user) => ({
                value: user.id,
                title: user.name,
            }))
        },

        prepareTickets(state) {
            return state.tickets.map((ticket) => ({
                id: ticket.id,
                link: {name: 'tickets.show', params: {id: ticket.id}},
                title: ticket.title,
                content_left: ticket.content,
                content_right_top: `Status: ${ticket.status === 'pending' ? 'Em aberto' : 'Fechado'}`,
                content_right_bottom: `Criado em ${ticket.created_at}`,
            }))
        },
    },

    actions: {
        fetchTickets({commit}) {
            commit('SET_LOADING', true)

            axios.get(`${ENDPOINT}`)
                .then((response) => {
                    commit('SET_TICKETS', response.data.data)
                })
                .catch(error => {
                    console.error(error)
                    notify({
                        type: 'error',
                        title: 'Oops',
                        text: 'ocorreu um erro ao buscar informações, tente novamente!',
                        duration: 2000,
                    })
                })
                .finally(() => {
                    commit('SET_LOADING', false)
                })
        },
        createTicket({commit}, payload) {
            commit('SET_LOADING', true)

            axios.post(`${ENDPOINT}`, payload)
                .then((response) => {
                    commit('SET_TICKET', response.data.data)
                    notify({
                        type: 'success',
                        title: 'Conforme solicitado...',
                        text: 'Chamado criado com sucesso!',
                        duration: 2000,
                    })
                })
                .catch(error => {
                    console.error(error)
                    notify({
                        type: 'error',
                        title: 'Oops',
                        text: 'ocorreu um erro ao buscar informações, tente novamente!',
                        duration: 2000,
                    })
                })
                .finally(() => {
                    commit('SET_LOADING', false)
                })
        },
        getTicket({commit}, ticketId) {
            parseInt(ticketId)
            if (!ticketId) return

            axios.get(`${ENDPOINT}/${ticketId}`)
                .then((response) => {
                    commit('SET_TICKET', response.data.data)
                })
                .catch(error => {
                    console.error(error)
                    notify({
                        type: 'error',
                        title: 'Oops',
                        text: 'ocorreu um erro ao buscar informações, tente novamente!',
                        duration: 2000,
                    })
                })
        },
        newResponse({state, commit, dispatch}, payload) {
            commit('SET_FORMLOADING', true)
            const ticketId = state.ticket.id

            payload.type = 'response'

            axios.post(`${ENDPOINT}/${ticketId}/response`, payload)
                .then(() => {
                    notify({
                        type: 'success',
                        title: 'Conforme solicitado...',
                        text: 'Sua resposta foi enviada com sucesso!',
                        duration: 2000,
                    })

                    dispatch('getTicket', ticketId)
                })
                .catch(error => {
                    console.error(error)
                    notify({
                        type: 'error',
                        title: 'Oops',
                        text: 'ocorreu um erro ao buscar informações, tente novamente!',
                        duration: 2000,
                    })
                })
                .finally(() => {
                    commit('SET_FORMLOADING', false)
                })
        },
        updateStatus({commit, dispatch}, ticketId) {
            commit('SET_FORMLOADING', true)

            const payload = {
                status: 'finished',
            }

            parseInt(ticketId)
            if (!ticketId) return

            axios.post(`${ENDPOINT}/${ticketId}`, payload)
                .then(() => {
                    dispatch('getTicket', ticketId)
                    notify({
                        type: 'success',
                        title: 'Conforme solicitado...',
                        text: `O Chamado ${ticketId} foi fechado com sucesso!`,
                        duration: 2000,
                    })
                })
                .catch(error => {
                    console.error(error)
                    notify({
                        type: 'error',
                        title: 'Oops',
                        text: 'ocorreu um erro ao buscar informações, tente novamente!',
                        duration: 2000,
                    })
                })
                .finally(() => {
                    commit('SET_FORMLOADING', false)
                })
        },
        transferTicket({commit, dispatch}, payload) {
            commit('SET_FORMLOADING', true)

            const ticketId = payload.ticketId

            axios.post(`${ENDPOINT}/${ticketId}/response`, payload)
                .then(() => {
                    dispatch('getTicket', ticketId)
                    notify({
                        type: 'success',
                        title: 'Conforme solicitado...',
                        text: `O Chamado #${ticketId} foi transferido com sucesso!`,
                        duration: 2000,
                    })
                })
                .catch(error => {
                    console.error(error)
                    notify({
                        type: 'error',
                        title: 'Oops',
                        text: 'ocorreu um erro ao buscar informações, tente novamente!',
                        duration: 2000,
                    })
                })
                .finally(() => {
                    commit('SET_FORMLOADING', false)
                })
        },
        fetchUsers({commit}) {
            axios.get('v1/users').then((response) => {
                commit('SET_USERS', response.data.data)
            })
        },
    },
}
